/** Site layout shell — used by all public routes. */
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export function SiteLayout() {
  return (
    <div className="relative min-h-screen">
      <div className="page-aura" aria-hidden="true" />
      <Navbar />
      <main className="relative z-[1] pt-[120px]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
